import { Component, computed, inject, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { PhoneReport } from '../../../../shared/models/phone-report.model';
import { PhoneReportService } from '../../../../shared/services/phone-report.service';

type PhonesReportsTableActionsParams = ICellRendererParams & {
  isDeleteReportDisabled: boolean;
};

@Component({
  standalone: false,
  selector: 'app-phones-reports-table-actions',
  templateUrl: './phones-reports-table-actions.component.html',
  styleUrls: ['./phones-reports-table-actions.component.scss'],
})
export class PhonesReportsTableActionsComponent implements ICellRendererAngularComp {
  private readonly phoneReportService = inject(PhoneReportService);

  readonly currentRow = signal<PhoneReport>(null);
  readonly isDeleteReportDisabled = signal<boolean>(false);

  readonly tooltipText = computed(() => (this.isDeleteReportDisabled() ? 'You cannot delete this report' : 'Delete report'));

  agInit(params: PhonesReportsTableActionsParams): void {
    this.currentRow.set(params.data);
    this.isDeleteReportDisabled.set(params.isDeleteReportDisabled);
  }

  refresh(params: PhonesReportsTableActionsParams) {
    return true;
  }

  onClick(clickedItem: string) {
    if (this.isDeleteReportDisabled()) return;

    this.phoneReportService.announceAction({ name: clickedItem, row: this.currentRow(), column: 'action' });
  }
}
